import { useQueryClient } from "@tanstack/react-query";
import { useSocketEvent } from "@/hooks/useSocketEvent";
import { SocketEvents } from "@/sockets/socket";
import type { RideRow } from "@/types/domain";

/**
 * Keeps the Live Rides table current without a page refresh: the backend
 * emits `admin:ride:update` (packages/websocket toAdmins) on every ride
 * lifecycle change, so we invalidate the active-rides query and TanStack
 * Query refetches it immediately (on top of its own polling fallback in
 * useLiveRides).
 */
export function useRideRealtimeSync() {
  const queryClient = useQueryClient();

  useSocketEvent<RideRow>(SocketEvents.AdminRideUpdate, () => {
    queryClient.invalidateQueries({ queryKey: ["rides"] });
  });
}
